import type { FC } from 'react';
import React, { useState } from 'react';
import type { ModifierStyles } from 'src/routes/SeoApp/domain/state/modifier/types';
import { formatCurrency } from 'src/utils/stringUtils';
import styled from 'styled-components';

import Icon from '../../../../../components/Icon';

interface Props {
  className?: string;
  showMoreLabel: string;
  isMobile: boolean;
  list: {
    link: string;
    text: string;
    price?: number | string;
  }[];
  modifierStyles: ModifierStyles;
}

export const List: FC<Props> = (props) => {
  const { className, list, showMoreLabel, isMobile, modifierStyles } = props;
  const [showAll, setShowAll] = useState(list.length <= 5);
  const handleShowMore = () => setShowAll(!showAll);

  let listCountOffset = list.length;
  const mobileCountOffset = 6;
  if (isMobile) {
    listCountOffset = showAll ? list.length : mobileCountOffset;
  }

  const dummy: any = {};

  return (
    <>
      <div className={className}>
        {list.map((item, index) => {
          const { link, text, price } = item;

          return (
            index < listCountOffset && (
              <ListItem key={`${link}`}>
                <Anchor href={link} linkColor={modifierStyles.linkColor}>
                  {text}
                </Anchor>
                {price ? (
                  <StyledPrice
                    textColor={modifierStyles.textColor}
                  >{`от ${formatCurrency(price)}`}</StyledPrice>
                ) : null}
              </ListItem>
            )
          );
        })}
      </div>
      {isMobile && !showAll && (
        <StyledShowMore
          type="button"
          onClick={handleShowMore}
          textColor={modifierStyles.textColor}
        >
          {showMoreLabel}
          <Icon type="arrow-down" {...dummy} />
        </StyledShowMore>
      )}
    </>
  );
};

const ListItem = styled.div`
  margin: 4px 0;
  display: flex;
  justify-content: space-between;
`;

const Anchor = styled.a<{ linkColor?: string }>`
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
  color: ${({ linkColor }) => linkColor || '#007aff'};
`;

const StyledPrice = styled.span<{ textColor?: string }>`
  white-space: nowrap;

  ${({ textColor }) => textColor && `color: ${textColor}`};
`;

const StyledShowMore = styled.button<{ textColor?: string }>`
  display: flex;
  align-items: center;
  text-align: left;
  color: ${({ textColor }) => textColor || '#919499'};
  background-color: transparent;
  border: none;

  svg {
    margin-left: 3px;
    width: 12px;
    height: 9px;
    transform: rotate(180deg);

    ${({ textColor }) => textColor && `path { fill: ${textColor} }`};
  }
`;
